import Vector from "../vector";
export class LongConstVector extends Vector {
    constructor(name, value, sizeOrNullabilityBuffer) {
        super(name, BigInt64Array.of(value), sizeOrNullabilityBuffer);
    }
    getValueFromBuffer(index) {
        return this.dataBuffer[0];
    }
}
//# sourceMappingURL=longConstVector.js.map